import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import OurLeaderShip from "../../component/OurLeaderShip";
import {
  fetchBotDirectory,
  fetchTeamLeaders,
} from "../../../redux/action/moreAction";

const TeamDirectory = () => {
  const dispatch = useDispatch();
  const { isLoading1, teamLeadersList } = useSelector(
    (state) => state.moreReducer
  );
  const { isLoading } = useSelector((state) => state.authReducer);

  useEffect(() => {
    dispatch(fetchTeamLeaders());
    dispatch(fetchBotDirectory());
  }, []);

  if (isLoading1 ) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Team Directory"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Team Directory",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />
        <OurLeaderShip list={teamLeadersList} isTeams={true}/>

        <Footer />
      </div>
    </>
  );
};

export default TeamDirectory;
